import { render, staticRenderFns } from "./uploadVideo.vue?vue&type=template&id=1e61dd2d&scoped=true&"
import script from "./uploadVideo.vue?vue&type=script&lang=js&"
export * from "./uploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./uploadVideo.vue?vue&type=style&index=0&id=1e61dd2d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e61dd2d",
  null
  
)

export default component.exports